/**
 * Texture loading and management
 */

export function loadTexture(gl, imageSrc, anisotropicExt, callback) {
  const texture = gl.createTexture();
  const image = new Image();
  image.crossOrigin = 'anonymous';

  image.onload = () => {
    console.log('Image loaded:', imageSrc, 'Size:', image.width, 'x', image.height);

    gl.bindTexture(gl.TEXTURE_2D, texture);

    // Create a canvas to convert the image to RGBA if needed
    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = image.width;
    tempCanvas.height = image.height;
    const tempCtx = tempCanvas.getContext('2d');
    tempCtx.drawImage(image, 0, 0);

    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, tempCanvas);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

    // Check if texture is power of two
    const isPowerOf2 = (value) => (value & (value - 1)) === 0;
    if (isPowerOf2(image.width) && isPowerOf2(image.height)) {
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.generateMipmap(gl.TEXTURE_2D);

      if (anisotropicExt) {
        const maxAnisotropy = gl.getParameter(anisotropicExt.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        gl.texParameterf(gl.TEXTURE_2D, anisotropicExt.TEXTURE_MAX_ANISOTROPY_EXT, maxAnisotropy);
      }
    } else {
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    }

    console.log('Texture created successfully');

    if (callback) {
      callback(texture, image.width, image.height);
    }
  };

  image.onerror = () => {
    console.error('Failed to load texture:', imageSrc);
  };

  image.src = imageSrc;
}
